import { useCallback, useEffect, useRef, useState } from 'react';

import { formatDuration } from 'shared/utils/formatDuration';

type StopwatchTimerProps = {
  timerLimit?: number; // in seconds
  onStop?: () => void;
  isRunning: boolean;
};

export const AudioRecorderStopwatchTimer = ({
  onStop,
  timerLimit,
  isRunning = true,
}: StopwatchTimerProps) => {
  let timeInterval = useRef<NodeJS.Timer | null>(null);

  const [timer, setTimer] = useState(0);
  const [isTimerOn, setIsTimerOn] = useState(false);

  const startTimer = useCallback(() => {
    setIsTimerOn(true);
    timeInterval.current = setInterval(() => {
      setTimer((prev) => prev + 1);
    }, 1000);
  }, []);

  const stopTimer = useCallback(() => {
    setIsTimerOn(false);
    if (timeInterval.current) {
      clearInterval(timeInterval.current);
      timeInterval.current = null;
    }
  }, []);

  useEffect(() => {
    if (!isRunning) {
      stopTimer();
    }
  }, [isRunning, stopTimer]);

  useEffect(() => {
    if (isTimerOn && timerLimit && timer >= timerLimit) {
      stopTimer();
      if (onStop) {
        onStop();
      }
    }
  }, [stopTimer, isTimerOn, timerLimit, timer, onStop]);

  useEffect(() => {
    return () => {
      stopTimer();
    };
  }, [stopTimer]);

  useEffect(() => {
    startTimer();
  }, [startTimer]);

  return <div>{formatDuration(timer)}</div>;
};
